<template>
  <!-- 当日行情表 -->
  <div>
    <div class="report_title">
      <label class="report-line" />
      <span class="report-title">当日行情表</span>
      <exportConfig
        :all-head="allHead"
        :header-name="headerName"
      />
    </div>
    <el-table :data="tableData">
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <af-table-column
        fixed
        prop="goodsCode"
        label="购销计划"
      />
      <af-table-column
        fixed
        prop="openingPrice"
        label="首笔价"
      />
      <af-table-column
        fixed
        prop="highestPrice"
        label="最高价"
      />
      <af-table-column
        prop="lowestPrice"
        label="最低价"
      />
      <af-table-column
        prop="newDealPrice"
        label="中间价"
      />
      <af-table-column
        prop="changePrice"
        label="幅度"
      />
      <af-table-column
        prop="transactionVolume"
        label="成交量(笔)"
      />
      <af-table-column
        prop="positions"
        label="约定单量(笔)"
      />
      <af-table-column
        prop="settlementPriceSafe"
        label="预计报价"
      />
    </el-table>
    <MoreData
      :all-data="allData"
      :table-data.sync="tableData"
    />
  </div>
</template>
<script>
import api from '@/api'
import MoreData from '@/components/more-data'
import exportConfig from '@/components/exportConfig'

export default {
  name: 'DailyQuotationSheet',
  components: {
    MoreData,
    exportConfig,
  },
  props: {
    query: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      currentPage: 1,
      total: 0,
      pageSize: 10,
      allHead: [{
        fieldLabel: '购销计划',
        excelColumn: 'goodsCode'
      },
      {
        fieldLabel: '首笔价',
        excelColumn: 'openingPrice'
      },
      {
        fieldLabel: '最高价',
        excelColumn: 'highestPrice'
      },
      {
        fieldLabel: '最低价',
        excelColumn: 'lowestPrice'
      },
      {
        fieldLabel: '中间价',
        excelColumn: 'newDealPrice'
      },
      {
        fieldLabel: '幅度',
        excelColumn: 'changePrice'
      },
      {
        fieldLabel: '成交量(笔)',
        excelColumn: 'transactionVolume'
      },
      {
        fieldLabel: '约定单量(笔)',
        excelColumn: 'positions'
      },
      {
        fieldLabel: '预计报价',
        excelColumn: 'settlementPriceSafe'
      },
      ],
      tableData: [], // 表格数据
      allData: [],
      headerName: '购销计划一览表_当日行情表',
    }
  },
  methods: {
    // 分页查询
    async fetchList (currentPage, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentPage = currentPage || this.currentPage || 1
      let param = {
        ...this.query,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      param.tradingDay = param.date ? this.$dayjs(this.query.date).format('YYYYMMDD')
        : '' // 默认时间，不附带时间将会返回所有数据，而且连分页都没做
      let res = await api.spotPurchaseSaleInquiry.DailyQuotationSheet(param)
      this.allData = res.data || []
    },
    changePage (page) {
      this.fetchList(page)
    },
    changeSort (prop) {},
  }
}

</script>
<style lang="scss" scoped>
  ::v-deep .el-table .el-table__body-wrapper tbody>tr:last-child {

    td:nth-child(5) div,
    td:nth-child(6) div,
    td:nth-child(7) div,
    td:nth-child(10) div {
      display: none;
    }
  }

  ::v-deep .el-table__fixed-body-wrapper tbody tr:last-child {

    td:nth-child(3) div,
    td:nth-child(4) div {
      display: none;
    }

  }

</style>
